import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47fd4cc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = { class: "kanban-column__header" }
const _hoisted_3 = { class: "kanban-column__indicators-wrap" }
const _hoisted_4 = { class: "kanban-column__count-card" }
const _hoisted_5 = { class: "kanban-column__tools-wrap" }
const _hoisted_6 = { class: "kanban-column__list-card-area" }

import { computed, onMounted, PropType } from "vue";
import { GroupedTaskItemModel, TasksKanbanGroupingModel } from "../../models";


export default /*#__PURE__*/_defineComponent({
  __name: 'KanbanColumn',
  props: {
  /**Группировка */
  grouping: {
    type: Object as PropType<TasksKanbanGroupingModel | GroupedTaskItemModel>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const color = computed(() => {
  if (props.grouping.Status) return props.grouping.Status.Color;
  if (props.grouping.Priority)
    return props.grouping.Priority.Color ?? "var(--bg-secondary, #F8F6F9)";
  if (props.grouping.Tag) return props.grouping.Tag.Color;
  return "var(--bg-secondary, #F8F6F9)";
});

const opacity = computed(() => {
  return props.grouping.Status || props.grouping.Priority?.Color || props.grouping.Tag
    ? "0.1"
    : "1";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "kanban-column",
    style: _normalizeStyle({ '--kanban-column-color': color.value, '--kanban-column-opacity': opacity.value })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "indicator"),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "count")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "tools")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "cards")
    ])
  ], 4))
}
}

})